let domHref = document?.location?.href;
let headerHeight = document?.querySelector(`#shopify-section-header`)?.clientHeight || 0;
let podFaqs = document?.querySelector(`.RQSupportPageMainWrapper.bodypod-page-faq`);
let bandFaqs = document?.querySelector(`.RQSupportPageMainWrapper.band-page-faq`);
if ( domHref.includes(`?page=band`) ){
    window.scrollTo({
        top: bandFaqs.offsetTop,
        behavior: 'smooth'
    }); 
}else if( domHref.includes(`?page=hume-pod`) ){
    window.scrollTo({
        top: podFaqs.offsetTop,
        behavior: 'smooth'
    }); 
}

if ( domHref.includes(`?page=band&technology`) ){
    bandFaqs?.querySelectorAll(`[tab-data]`).forEach((tb)=>{tb?.classList.remove('active')});
    bandFaqs?.querySelectorAll(`[tab-content]`).forEach((tbc)=>{tbc?.classList.remove('active')});
    bandFaqs?.querySelector(`[tab-data="technology"]`)?.classList.add('active');
    bandFaqs?.querySelector(`[tab-content="technology"]`)?.classList.add('active');
}else if( domHref.includes(`?page=hume-pod&sensor-technology`) ){
    podFaqs?.querySelectorAll(`[tab-data]`).forEach((tb)=>{tb?.classList.remove('active')});
    podFaqs?.querySelectorAll(`[tab-content]`).forEach((tbc)=>{tbc?.classList.remove('active')});
    podFaqs?.querySelector(`[tab-data="hume-pod-sensor-technology"]`)?.classList.add('active');
    podFaqs?.querySelector(`[tab-content="hume-pod-sensor-technology"]`)?.classList.add('active');
}else if( domHref.includes(`?page=hume-pod&body-composition-biometric-benchmarks`) ){
    podFaqs?.querySelectorAll(`[tab-data]`).forEach((tb)=>{tb?.classList.remove('active')});
    podFaqs?.querySelectorAll(`[tab-content]`).forEach((tbc)=>{tbc?.classList.remove('active')});
    podFaqs?.querySelector(`[tab-data="body-composition-biometric-benchmarks"]`)?.classList.add('active');
    podFaqs?.querySelector(`[tab-content="body-composition-biometric-benchmarks"]`)?.classList.add('active');
}

